import autoAllowEvent from "js/src/tito/autoAllowEvent.js";
import Vue from "vue";
import TitoWidget from "js/src/components/widget/TitoWidget.vue";

export default function (item) {
  const options = item[1];
  const el = options.el;
  delete options.el;

  if (document.querySelector(el)) {
    autoAllowEvent(options.event)

    new Vue({
      el: el,
      render: (h) => h(TitoWidget, { props: options }),
    });
    // document.querySelector(el).innerHTML = `<tito-widget event="${
    //   options.event
    // }" releases="${options.releases}"/>`;
  } else {
    console.error(
      "[Tito]",
      "Element",
      el,
      "not found when attempting to mount a widget"
    );
  }
}
